import * as echarts from 'echarts';

export const EBIOS_THEME_NAME = 'ebios';

export const SEVERITY_COLORS = {
  Catastrophique: '#1F2937',
  Critique: '#DC2626',
  Majeur: '#EA580C',
  'Modéré': '#D97706',
  Mineur: '#059669',
  'Non défini': '#94A3B8'
};

echarts.registerTheme(EBIOS_THEME_NAME, {
  color: ['#6366F1', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#06B6D4', '#EC4899', '#64748B'],
  backgroundColor: '#ffffff',
  textStyle: {
    fontFamily: 'inherit'
  },
  tooltip: {
    backgroundColor: '#ffffff',
    borderColor: '#E5E7EB',
    borderWidth: 1,
    textStyle: {
      color: '#111827',
      fontFamily: 'inherit',
      fontSize: 12
    },
    extraCssText: 'border-radius: 8px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); padding: 8px 12px;'
  },
  categoryAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: '#E5E7EB'
      }
    },
    axisTick: {
      show: true,
      lineStyle: {
        color: '#6B7280'
      }
    },
    axisLabel: {
      color: '#6B7280'
    },
    splitLine: {
      show: false
    }
  },
  valueAxis: {
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    axisLabel: {
      color: '#6B7280'
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: '#E5E7EB'
      }
    }
  },
  legend: {
    textStyle: {
      color: '#374151',
      fontFamily: 'inherit'
    }
  }
});
